import ApiService from '../../../../../services/ApiService'
import GeneralService from '../../../../../services/GeneralService'
import Utils from '../../../../../Utils/FormatDate'
import TemplateSelect from '../../../Checklists/components/checklistTemplate/templateSelect/templateSelect.vue'
// import TTable from "../../../../../components/T/TTable.vue";
import InspectionRoutine from '../InspectionRoutineModal/index'
export default {
  components: {
    TemplateSelect,
    InspectionRoutine,
    // TTable,
  },

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.userType = this.institution.userType
    this.mainType = this.userLogged.mainType
    this.institutionId = this.institution.id

    if (this.userType > 4 && this.userType != 8) {
      this.unidadeId = this.userLogged.unidadeId
    }

    this.status = [this.serviceOrderStatus[0].value]
    this.filter.status = [0]

    await this.getInstitutions()

    if (this.userLogged.userType > 1) {
      await this.getUserUnidades()
    } else {
      await this.getUnidades()
    }

    await Promise.all([
      this.getWorkshops(),
      this.getDepartments(),
      this.getSolutions(),
      this.getStandardEquipments(),
      this.getUsers(),
      this.getUsersByType(),
      this.getManufacturers(),
      this.getSuppliers(),
    ])

    this.getWorkshops()

    if (this.unidades.length == 1) {
      this.unidadeId = this.unidades[0].id
    }
    await this.updateTable()

    const columns = JSON.parse(this.userLogged.osColumns)
    this.headers = columns
      ? this.headers.map((x) => {
          const find = columns.find((y) => y.text == x.text)

          if (find) {
            return find
          } else {
            return x
          }
        })
      : this.headers

    if (!this.institution.departmentTypes.includes(1)) {
      this.headers = this.headers.filter((x) => x.text != 'Oficina')
    }
  },

  data() {
    return {
      manufacturerLoading: false,
      manufacturers: [],
      supplierLoading: false,
      suppliers: [],
      typeOSSearch: '',
      unitSearch: '',
      statusSearch: '',
      search: '',
      subSectorSearch: '',
      equipSearch: '',
      institution: {},
      localDepartments: [],
      workshopTypes: [
        { text: 'Engenharia Clínica', value: 0 },
        { text: 'Carpintaria', value: 1 },
        { text: 'Elétrica', value: 2 },
        { text: 'Hidráulica', value: 3 },
        { text: 'Climatização', value: 4 },
        { text: 'Gasoterapia', value: 5 },
        { text: 'Zeladoria', value: 6 },
        { text: 'Vidraçaria', value: 7 },
        { text: 'Mecânica', value: 8 },
        { text: 'Serralheria', value: 9 },
        { text: 'Predial Civil', value: 10 },
        { text: 'Pintura Predial', value: 11 },
        { text: 'Pintura Industrial', value: 12 },
      ],
      situations: [
        { text: 'Aluguel', value: 0 },
        { text: 'Comodato', value: 1 },
        { text: 'De médico/Equipe', value: 2 },
        { text: 'Empréstimo', value: 3 },
        { text: 'Próprio', value: 4 },
        { text: 'Terceiros', value: 5 },
        { text: 'Convênio', value: 6 },
      ],
      solutionLoading: false,
      solutions: [],
      responsibleName: '',
      errorMessage: '',
      expanded: [],
      totalItensOnPage: 0,
      menuStartDate: false,
      menuEndDate: false,
      menuInitialCloseDate: false,
      menuFinalCloseDate: false,
      visible: false,
      activeOstemplateDialog: false,
      inactiveOsTemplateDialog: false,
      templateSelectDialog: false,
      aboutDialog: false,
      deleteDialog: false,
      deleteManyDialog: false,
      printDialog: false,
      buttonDeleteVisible: false,
      dialogKey: false,
      loading: false,
      institutionLoading: false,
      unidadeLoading: false,
      departmentLoading: false,
      userLoading: false,
      standardEquipmentLoading: false,
      printChecklistLoading: false,
      printLoading: false,
      error: false,
      newChecklist: false,
      departmentInactive: false,
      startDate: null,
      endDate: null,
      requestMinDate: null,
      initialCloseDate: null,
      finalCloseDate: null,
      closeMinDate: null,
      search: null,
      sortBy: [],
      sortDesc: [],
      serviceOrders: [],
      serviceOrdersSelected: [],
      currentServiceOrder: {},
      serviceOrderCosts: [],
      serviceOrderServices: [],
      institutionId: null,
      institutions: [],
      unidadeId: null,
      unidades: [],
      departmentId: null,
      departments: [],
      userId: null,
      users: [],
      userLogged: {},
      userType: null,
      standardEquipmentId: null,
      standardEquipments: [],
      serviceOrderTypes: [
        'Treinamento',
        'Segurança elétrica',
        'Preventiva',
        'Instalação',
        'Rotina de Inspeção',
        'Corretiva',
        'Calibração',
        'Validação/Qualificação',
        'Serviço Administrativo',
        'Empréstimo',
        'Tecnovigilancia',
      ],
      causeDefects: [
        'Não aplicável',
        'Falha intríseca',
        'Falha infraestrutura',
        'Erro operacional',
        'Dano acidental',
        'Abuso na utilização',
      ],
      serviceOrderStatus: [
        { text: 'Abertas', value: 0 },
        { text: 'Fechadas', value: 1 },
        { text: 'Manutenção terceirizada in loco', value: 2 },
        { text: 'Manutenção terceirizada externa', value: 3 },
        { text: 'Manutenção interna', value: 4 },
        { text: 'Aguardando peça', value: 5 },
        { text: 'Aguardando orçamento', value: 6 },
        { text: 'Aguardando avaliação externa', value: 7 },
        { text: 'Aguardando aprovação de orçamento', value: 8 },
        { text: 'Aguardando liberação do setor', value: 9 },
      ],
      responsibilities: ['Interna', 'Externa'],
      categories: ['Equipamento', 'Setor'],
      page: 1,
      totalPages: 1,
      pageSize: 10,
      sizes: [10, 30, 90, 180],
      totalItems: 0,
      filter: {
        isArchived: false,
        page: 1,
        pageSize: 10,
        institutionId: null,
        unidadeIds: [],
        standardEquipmentId: null,
        equipmentName: null,
        equipmentSerialNumber: null,
        equipmentIdentification: null,
        equipmentDepartmentId: null,
        equipmentCriticalityMin: null,
        equipmentCriticalityMax: null,
        equipmentPropertyCode: null,
        serviceOrderType: [5],
        userResponsibleStep: null,
        serviceOrderNumber: null,
        requestStartDate: null,
        requestEndDate: null,
        initialCloseDate: null,
        finalCloseDate: null,
        causeDefect: null,
        status: null,
        genericSearch: null,
        responsibility: null,
        category: null,
        ordination: null,
      },
      serviceOrderName: null,
      standardEquipmentName: null,
      serviceOrderNumber: null,
      serviceOrderType: null,
      serviceOrderLastStep: null,
      serviceOrderRequeter: null,
      serviceOrderRequestDate: null,
      serviceOrderAttendDate: null,
      serviceOrderCloseDate: null,
      equipmentName: null,
      equipmentSerialNumber: null,
      equipmentIdentification: null,
      equipmentDepartmentId: null,
      equipmentCriticalityMin: null,
      equipmentCriticalityMax: null,
      equipmentPropertyCode: null,
      serviceOrderTypeSelected: ['Corretiva'],
      userResponsibleStep: null,
      requestStartDate: null,
      requestEndDate: null,
      serviceOrderinitialCloseDate: null,
      serviceOrderfinalCloseDate: null,
      causeDefect: null,
      status: null,
      genericSearch: null,
      responsibility: null,
      category: null,
      headMenu: false,
      statusStep: [
        'Manutenção terceirizada in loco',
        'Manutenção terceirizada externa',
        'Manutenção interna',
        'Aguardando peça',
        'Aguardando orçamento',
        'Aguardando avaliação externa',
        'Aguardando aprovação de orçamento',
        'Aguardando liberação do setor',
        'Deslocamento',
        'Equipamento não encontrado',
      ],
      headers: [
        {
          text: 'Nº O.S.',
          align: 'center',
          value: 'number',
          active: true,
          width: 20,
        },
        {
          text: 'Estado Etapa',
          align: 'center',
          value: 'services[0].statusStepServiceOrder',
          active: false,
          width: 20,
        },
        {
          text: 'Código Patrimônio',
          align: 'center',
          value: 'equipment.propertyCode',
          active: false,
          width: 20,
        },
        {
          text: 'Fabricante',
          align: 'center',
          value: 'equipment.manufacturer',
          active: false,
          width: 20,
        },
        {
          text: 'Centro de custo',
          align: 'center',
          value: 'costCenter.name',
          active: false,
          width: 20,
        },
        {
          text: 'Número de série',
          align: 'center',
          value: 'equipment.serialNumber',
          active: false,
          width: 20,
        },
        {
          text: 'Nome O.S.',
          align: 'center',
          value: 'name',
          active: true,
          width: 100,
        },
        {
          text: 'Solicitante',
          align: 'center',
          value: 'requester',
          active: false,
          width: 130,
        },
        {
          text: 'Unidade',
          align: 'center',
          value: 'unidade.name',
          active: false,
          width: 20,
        },
        {
          text: 'Setor',
          align: 'center',
          value: 'department.name',
          active: false,
          width: 20,
        },
        {
          text: 'Sub-Setor',
          align: 'center',
          value: 'subDepartment.name',
          active: false,
          width: 20,
        },
        {
          text: 'Equipamento',
          align: 'center',
          value: 'equipment.name',
          active: false,
          width: 130,
        },
        {
          text: 'E. Padrão',
          align: 'center',
          value: 'equipment.standardEquipment.name',
          active: true,
          width: 100,
        },
        {
          text: 'Tipo O.S.',
          align: 'center',
          value: 'serviceOrderType',
          active: true,
          width: 60,
        },
        {
          text: 'Responsável',
          align: 'center',
          value: 'responsibleName',
          active: false,
          width: 20,
        },
        {
          text: 'Dt.Solic.',
          align: 'center',
          value: 'dateTimeRequest',
          active: true,
          width: 80,
        },
        {
          text: 'Dt.Fecham.',
          align: 'center',
          value: 'closeServiceOrderDateTime',
          active: true,
          width: 80,
        },
        {
          text: 'Equip. ID',
          align: 'center',
          value: 'equipment.identification',
          active: true,
          width: 130,
        },
        {
          text: 'Oficina',
          align: 'center',
          value: 'workshopId',
          active: false,
          width: 130,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
          sortable: false,
          active: true,
          width: 250,
        },
      ],
      headersMobile: [
        {
          text: 'Nome O.S.',
          align: 'center',
          active: true,
          value: 'name',
        },
        {
          text: 'Ações',
          active: true,
          value: 'actions',
          sortable: false,
        },
      ],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      apiService: new ApiService(),
      generalService: new GeneralService(),
      responsibleUsers: [],
      inpectionRoutine: false,
      orderId: null,
      orderKey: false,
      menuLoading: false,
      workshopTypes: [],
      group: null,
      sendEmailDialog: false,
      emailToSend: '',
      emailRules: [
        (v) => !!v || 'E-mail requerido',
        (v) => /.+@.+\..+/.test(v) || 'E-mail inválido',
      ],
      sendEmailDialogKey: false,
    }
  },

  computed: {
    subDepartments() {
      const departments = this.localDepartments.filter(
        (x) =>
          this.filter.equipmentDepartmentIds &&
          this.filter.equipmentDepartmentIds.includes(x.id)
      )

      return departments.map((x) => x.subDepartments).flat(1)
    },

    filtreredDepartments() {
      if (!this.filter.unidadeIds || this.filter.unidadeIds.length === 0) {
        return this.localDepartments
      }

      return this.localDepartments.filter((x) =>
        this.filter.unidadeIds.includes(x.unidadeId)
      )
    },
  },

  methods: {
    async getWorkshops() {
      await this.apiService
        .get('workshop/' + this.institution.id, true, false)
        .then((response) => {
          this.workshopTypes = response.content
        })
    },

    getManufacturers() {
      this.manufacturerLoading = true
      this.apiService
        .get(`manufacturer/list/${this.institutionId}`)
        .then((response) => {
          this.manufacturers = response.content
          this.manufacturerLoading = false
        })
        .catch(() => {
          this.manufacturerLoading = false
        })
    },
    getSuppliers() {
      this.supplierLoading = true
      this.apiService
        .get(`supplier/list/${this.institutionId}`)
        .then((response) => {
          this.suppliers = response.content

          this.supplierLoading = false
        })
        .catch(() => {
          this.supplierLoading = false
        })
    },
    async getZip() {
      if (
        this.serviceOrdersSelected &&
        this.serviceOrdersSelected.length > 25
      ) {
        this.$toast.error(
          'Só é possível baixar 25 Ordens por vez, por favor selecione apenas 25 e tente novamente!'
        )
        return
      }

      this.$toast(
        `${this.$t('Imprimindo registros')}: ${
          this.serviceOrdersSelected.length
        } ${this.$t('selecionados')}`
      )
      const ids = this.serviceOrdersSelected.map((x) => x.id)
      await this.apiService
        .post(`serviceOrder/zip`, { ids })
        .then((response) => {
          var pedfResult = 'data:application/zip;base64,' + response.content
          const link = document.createElement('a')
          link.href = pedfResult
          link.setAttribute('download', `Ordens`)
          document.body.appendChild(link)
          link.click()
          this.serviceOrdersSelected = []
        })
    },

    getWorkshops() {
      this.apiService
        .get('workshop/' + this.institution.id)
        .then((response) => {
          this.workshopTypes = response.content
        })
    },

    updateHeaders() {
      this.menuLoading = true

      const json = JSON.stringify(this.headers)
      this.apiService
        .post('user/saveColumns/os', { columns: json })
        .then(() => {
          this.userLogged.osColumns = json

          localStorage.removeItem('user')
          localStorage.setItem('user', JSON.stringify(this.userLogged))
          this.$toast.success('Configuração salva no seu usuário!')

          this.headMenu = false
          this.menuLoading = false
        })
        .catch(() => {
          this.menuLoading = false
        })
    },

    unarchive(item) {
      this.apiService.get(`serviceOrder/unarchive/${item.id}`).then(() => {
        this.$toast.success('Ordem de serviço desarquivada com sucesso!')
        this.updateTable()
      })
    },

    async getUsersByType() {
      await this.apiService
        .get(`user/byType/${this.institutionId}`)
        .then((response) => {
          this.responsibleUsers = response.content
        })
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    addServiceOrder() {
      sessionStorage.clear()
      this.$router.push({ name: 'newServiceOrder' })
    },

    editServiceOrder(serviceOrder) {
      this.currentServiceOrder = serviceOrder
      const route = this.$router.resolve({
        path: `/editServiceOrder/${this.currentServiceOrder.id}`,
      })
      window.open(route.href, '_blank')
    },

    uploadDocument(serviceOrder) {
      sessionStorage.clear()

      const order = {
        id: serviceOrder.id,
        number: serviceOrder.number,
      }
      sessionStorage.setItem('serviceOrder', JSON.stringify(order))

      let routeData = this.$router.resolve({ path: '/uploadDocument' })
      window.open(routeData.href, '_blank')
    },

    deleteServiceOrder(serviceOrder) {
      this.currentServiceOrder = serviceOrder
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    deleteManySeviceOrders() {
      this.dialogKey = !this.dialogKey
      this.deleteManyDialog = true
    },

    openAbout(serviceOrder) {
      this.currentServiceOrder = serviceOrder
      this.dialogKey = !this.dialogKey
      this.aboutDialog = true
    },

    handleSortUpdate({ sortBy, sortDesc }) {
      if (sortBy[0] == 'number' && !sortDesc[0]) {
        this.filter.ordination = 0
      } else if (sortBy[0] == 'number' && sortDesc[0]) {
        this.filter.ordination = 1
      }
      this.updateTable()
    },

    setChecklistButtonColor(serviceOrder) {
      return serviceOrder.checklistServiceOrders.length > 0 &&
        serviceOrder.checklistServiceOrders[0].checklistResponse != null
        ? '#BBCF20'
        : '#426483'
    },

    openInspectionRoutine(item) {
      this.orderId = item.id
      this.orderKey = !this.orderKey
      this.inpectionRoutine = true
    },

    openChecklist(serviceOrder) {
      this.currentServiceOrder = serviceOrder
      if (this.userType < 4 || this.userType == 8) {
        if (
          serviceOrder.status == 0 &&
          serviceOrder.checklistTemplateId != null &&
          serviceOrder.checklists.length > 0
        ) {
          this.activeOstemplateDialog = true
        } else if (
          serviceOrder.status == 1 &&
          serviceOrder.checklistTemplateId != null &&
          serviceOrder.checklists.length > 0
        ) {
          this.inactiveOsTemplateDialog = true
        } else if (
          serviceOrder.department.status == 1 &&
          serviceOrder.checklistTemplateId != null &&
          serviceOrder.checklists.length > 0
        ) {
          this.inactiveOsTemplateDialog = true
        } else {
          this.openTemplateSelect()
        }
      } else if (
        serviceOrder.checklistTemplateId != null &&
        serviceOrder.checklists.length > 0
      ) {
        this.inactiveOsTemplateDialog = true
      } else {
        return
      }
    },

    openTemplateSelect() {
      this.newChecklist = true
      this.activeOstemplateDialog = false
      this.templateSelectDialog = true
      this.dialogKey = !this.dialogKey
    },

    async viewChecklist() {
      await this.apiService
        .get(
          `serviceOrder/getServiceOrder/${this.currentServiceOrder.institutionId}/${this.currentServiceOrder.id}`
        )
        .then((response) => {
          const checklist = response.content.checklists[0]
          const checklistServiceOrder = {
            ServiceOrderId: checklist.serviceOrderId,
            ChecklistId: checklist.id,
            isValidatorSigned: checklist.isValidatorSigned,
            EquipmentId: checklist.equipmentId,
          }
          sessionStorage.setItem(
            'checklist',
            JSON.stringify(checklistServiceOrder)
          )
          sessionStorage.setItem(
            'serviceOrder',
            JSON.stringify(this.currentServiceOrder)
          )
          const route = this.$router.resolve({
            path: '/formChecklist',
          })
          window.open(route.href, '_blank')
          this.activeOstemplateDialog = false
          this.inactiveOsTemplateDialog = false
        })
    },

    closeDialog() {
      this.dialog = false
      this.aboutDialog = false
      this.templateSelectDialog = false

      this.updateTable()
    },

    openCalibration(serviceOrder) {
      sessionStorage.clear()
      this.currentServiceOrder = serviceOrder
      sessionStorage.setItem(
        'serviceOrder',
        JSON.stringify(this.currentServiceOrder)
      )
      window.open('/formCalibration', '_blank').focus()
    },
    openCalibrationV2(serviceOrder) {
      if (serviceOrder.calibrationsV2.length > 0)
        this.$router.push(
          '/calibration/v2/print?id=' + serviceOrder.calibrationsV2[0].id
        )
      else
        this.$router.push('/calibration/v2/manage?orderId=' + serviceOrder.id)
    },
    openElectricalSafety(serviceOrder) {
      sessionStorage.clear()
      this.currentServiceOrder = serviceOrder
      sessionStorage.setItem(
        'serviceOrder',
        JSON.stringify(this.currentServiceOrder)
      )
      window.open('/formElectricalSafety', '_blank').focus()
    },

    openCalibrationV2(serviceOrder) {
      const route = this.$router.resolve({
        path:
          serviceOrder.calibrationsV2.length > 0
            ? '/calibration/v2/manage?id=' + serviceOrder.calibrationsV2[0].id
            : '/calibration/v2/manage?orderId=' + serviceOrder.id,
      })
      window.open(route.href, '_blank')
    },

    removeDepartment(item) {
      this.filter.equipmentDepartmentIds.splice(item, 1)
      this.filter.equipmentDepartmentIds = [
        ...this.filter.equipmentDepartmentIds,
      ]
    },
    removeSubDepartment(item) {
      this.filter.subDepartmentIds.splice(item, 1)
      this.filter.subDepartmentIds = [...this.filter.subDepartmentIds]
    },
    removeStandardEquipment(item) {
      this.filter.standardEquipmentIds.splice(item, 1)
      this.filter.standardEquipmentIds = [...this.filter.standardEquipmentIds]
    },
    removeStatus(item) {
      this.filter.status.splice(item, 1)
      this.filter.status = [...this.filter.status]
    },
    removeServiceOrderType(item) {
      this.serviceOrderTypeSelected.splice(
        this.serviceOrderTypeSelected.indexOf(item),
        1
      )
      this.serviceOrderTypeSelected = [...this.serviceOrderTypeSelected]
    },
    removeUnit(item) {
      this.filter.unidadeIds.splice(this.filter.unidadeIds.indexOf(item.id), 1)
      this.filter.unidadeIds = [...this.filter.unidadeIds]
    },

    isInactive(value) {
      if (value.department) {
        return value.department.status == 1 ? 'departmentInactive' : ''
      }
      return value && value.equipment && value.equipment.department.status == 1
        ? 'departmentInactive'
        : ''
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.unidadeId = this.unidadeId
      this.filter.standardEquipmentId = this.standardEquipmentId
      this.filter.equipmentName = this.equipmentName
      this.filter.equipmentSerialNumber = this.equipmentSerialNumber
      this.filter.equipmentIdentification = this.equipmentIdentification
      this.filter.equipmentDepartmentId = this.departmentId
      this.filter.equipmentCriticalityMin = this.equipmentCriticalityMin
      this.filter.equipmentCriticalityMax = this.equipmentCriticalityMax
      this.filter.equipmentPropertyCode = this.equipmentPropertyCode
      this.filter.userResponsibleStep = this.userId
      this.filter.serviceOrderNumber = this.serviceOrderNumber
      this.filter.requestStartDate = this.requestStartDate
      this.filter.requestEndDate = this.requestEndDate
      this.filter.responsibleName = this.responsibleName
      this.filter.initialCloseDate = this.serviceOrderinitialCloseDate
      this.filter.finalCloseDate = this.serviceOrderfinalCloseDate
      this.filter.causeDefect =
        this.causeDefects.indexOf(this.causeDefect) == -1
          ? null
          : this.causeDefects.indexOf(this.causeDefect)

      this.filter.genericSearch = this.genericSearch
      this.filter.responsibility =
        this.responsibilities.indexOf(this.responsibility) == -1
          ? null
          : this.responsibilities.indexOf(this.responsibility)
      this.filter.category =
        this.categories.indexOf(this.category) == -1
          ? null
          : this.categories.indexOf(this.category)

      if (this.serviceOrderTypeSelected.length > 0) {
        this.filter.serviceOrderType = []
        this.serviceOrderTypeSelected.map((type) => {
          this.filter.serviceOrderType.push(
            this.serviceOrderTypes.indexOf(type)
          )
        })
      } else {
        this.filter.serviceOrderType = []
      }
      if (this.filter.responsibility == 1) this.filter.internalTeam = null
      this.updateTable()
    },

    getLastStep(array) {
      const lastStep = array[array.length - 1]

      if (lastStep) {
        switch (lastStep.statusStepServiceOrder) {
          case 0:
            return 'Manutenção terceirizada in loco'
          case 1:
            return 'Manutenção terceirizada externa'
          case 2:
            return 'Manutenção interna'
          case 3:
            return 'Aguardando peça'
          case 4:
            return 'Aguardando orçamento'
          case 5:
            return 'Aguardando avaliação externa'
          case 6:
            return 'Aguardando aprovação de orçamento'
          case 7:
            return 'Aguardando liberação do setor'
          default:
            return 'Sem registro'
        }
      }
      return 'Sem registro'
    },

    async generateChecklistPDF() {
      const checklist = this.currentServiceOrder.checklists[0]
      const route = this.$router.resolve({
        path: `/printChecklist/${checklist.id}`,
      })
      window.open(route.href, '_blank')
      this.inactiveOsTemplateDialog = false
    },
    previewElectricalSafetyChecklistPDF(serviceOrder) {
      const checklistId = serviceOrder.arkMedsChecklist.id
      this.$router.push({
        name: 'ElectricalSafetyPreview',
        params: { id: checklistId },
      })
    },

    async generateElectricalSafetyChecklistPDF(serviceOrder) {
      try {
        const checklistId = serviceOrder.arkMedsChecklist.id
        const response = await this.apiService.post(
          `arkmeds/webhooks/generateElectricalSafetyPdf/${checklistId}`
        )
        if (response.statusCode === 200) {
          const pdfBase64 = response.message

          const pdfUrl = `data:application/pdf;base64,${pdfBase64}`
          const link = document.createElement('a')
          link.href = pdfUrl
          link.setAttribute(
            'download',
            `Checklist_${this.formatDate(new Date())}.pdf`
          )
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          this.$toast.success('PDF gerado com sucesso!')
        } else {
          this.$toast.error('Falha ao gerar o PDF.')
        }
      } catch (error) {
        console.error('Erro ao gerar PDF:', error)
        this.$toast.error('Erro ao gerar o PDF.')
      }
    },

    async updateTable() {
      this.loading = true
      this.filter.institutionId = this.institutionId

      if (this.userType > 4 && this.userType != 8) {
        this.filter.unidadeId = this.unidadeId
      }

      await this.apiService
        .post('serviceOrder/list', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.serviceOrders = response.content.serviceOrders
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.serviceOrders.length
          this.loading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    generateExcel() {
      this.filter.pageSize = null

      let now = new Date()
      var filename = `Ordens_Serviço_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`

      this.apiService
        .post('serviceOrder/excel', this.filter)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },

    async remove() {
      this.loading = true
      const serviceOrderId = this.currentServiceOrder.id
      const user = JSON.parse(localStorage.getItem('user'))
      const model = {
        serviceOrderId: serviceOrderId,
        archivedByuserId: user.id,
      }

      await this.apiService
        .delete(`serviceOrder/delete`, model)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.deleteDialog = false
    },

    async removeMany() {
      this.loading = true

      await this.apiService
        .delete('serviceOrder/deleteMany', this.serviceOrdersSelected)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
      this.deleteManyDialog = false
      this.buttonDeleteVisible = false
      this.serviceOrdersSelected = []
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
        })
      this.unidadeLoading = false
    },

    async getSolutions() {
      this.solutionLoading = true

      await this.apiService
        .get(`defectSolution/institution/${this.institutionId}`)
        .then((response) => {
          this.solutions = response.content
          this.solutionLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .get(`department/listActive/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content
          this.localDepartments = this.departments.filter((x) =>
            this.unidades.map((x) => x.id).includes(x.unidadeId)
          )
          this.departmentLoading = false
        })
    },

    async getStandardEquipments() {
      this.standardEquipmentLoading = true

      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institutionId
        )
      this.standardEquipmentLoading = false
    },

    getStandardEquipmentName(value) {
      const equipment = this.standardEquipments.find(
        (equipmentInstitution) =>
          equipmentInstitution.institutionStandardEquipmentId == value
      )

      if (equipment && equipment.standardEquipment) {
        return equipment.standardEquipment.name
      }
      return 'Sem registro'
    },

    async getUsers() {
      this.userLoading = true

      await this.apiService
        .get(`user/list/${this.institutionId}`)
        .then((response) => {
          this.users = response.content
          this.userLoading = false
        })
    },

    async generatePDF(serviceOrder) {
      this.currentServiceOrder = serviceOrder
      const route = this.$router.resolve({
        path: `printServiceOrder/${this.institutionId}/${this.currentServiceOrder.id}`,
      })
      window.open(route.href, '_blank')
    },

    async getTemplateItems(serviceOrder) {
      const checklist = {
        ChecklistTemplate: serviceOrder.checklistTemplate,
        ServiceOrderId: serviceOrder.id,
      }
      sessionStorage.setItem('checklist', JSON.stringify(checklist))
      this.$router.push('/formChecklist')
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    saveRequestDate(date) {
      this.startDate = this.formatInputDate(this.requestStartDate)
      this.$refs.menuStartDate.save(date)
      this.requestMinDate = new Date(this.requestStartDate)
        .toISOString()
        .substr(0, 10)
      this.endDate = this.formatInputDate(this.requestEndDate)
      this.$refs.menuEndDate.save(date)
    },

    saveCloseDate(date) {
      this.initialCloseDate = this.formatInputDate(
        this.serviceOrderinitialCloseDate
      )
      this.$refs.menuInitialCloseDate.save(date)
      this.closeMinDate = new Date(this.serviceOrderinitialCloseDate)
        .toISOString()
        .substr(0, 10)
      this.finalCloseDate = this.formatInputDate(
        this.serviceOrderfinalCloseDate
      )
      this.$refs.menuFinalCloseDate.save(date)
    },

    reset() {
      this.filter.internalTeam = null
      this.page = 1
      this.serviceOrderName = null
      this.responsibleName = ''
      this.standardEquipmentName = null
      this.serviceOrderNumber = null
      this.serviceOrderType = null
      this.serviceOrderLastStep = null
      this.serviceOrderRequeter = null
      this.serviceOrderRequestDate = null
      this.serviceOrderAttendDate = null
      this.serviceOrderCloseDate = null
      this.equipmentName = null
      this.equipmentSerialNumber = null
      this.equipmentIdentification = null
      this.equipmentDepartmentId = null
      this.equipmentCriticalityMin = null
      this.equipmentCriticalityMax = null
      this.equipmentPropertyCode = null
      this.serviceOrderTypeSelected = []
      this.userResponsibleStep = null
      this.requestStartDate = null
      this.startDate = null
      this.requestEndDate = null
      this.endDate = null
      this.serviceOrderinitialCloseDate = null
      this.initialCloseDate = null
      this.finalCloseDate = null
      this.serviceOrderfinalCloseDate = null
      this.causeDefect = null
      this.status = null
      this.genericSearch = null
      this.unidadeId = this.userType < 3 ? null : this.userLogged.unidadeId
      this.departmentId = null
      this.userId = null
      this.standardEquipmentId = null
      this.responsibility = null
      this.category = null
      this.serviceOrdersSelected = []
      this.filter = {
        isArchived: false,
        page: 1,
        pageSize: this.pageSize,
        institutionId: null,
        unidadeId: null,
        standardEquipmentIds: null,
        equipmentName: null,
        equipmentSerialNumber: null,
        equipmentIdentification: null,
        equipmentDepartmentId: null,
        equipmentCriticalityMin: null,
        equipmentCriticalityMax: null,
        equipmentPropertyCode: null,
        serviceOrderType: [],
        responsibleName: '',
        userResponsibleStep: null,
        serviceOrderNumber: null,
        requestStartDate: null,
        requestEndDate: null,
        initialCloseDate: null,
        finalCloseDate: null,
        causeDefect: null,
        status: null,
        genericSearch: null,
        responsibility: null,
        category: null,
      }
      this.updateTable()
    },

    openSendEmail() {
      this.sendEmailDialog = true
      this.emailToSend = ''
      this.sendEmailDialogKey = !this.sendEmailDialogKey
    },

    async sendEmail() {
      if (this.$refs.form.validate()) {
        const ids = this.serviceOrdersSelected.map((x) => x.id)
        await this.apiService
          .post(`serviceOrder/send-os-email`, {
            email: this.emailToSend,
            ids: ids,
          })
          .then((response) => {
            this.sendEmailDialog = false
            this.$toast.success('E-mail enviado com sucesso!')
          })
      }
    },

    menuSendSelecionActionClick(action) {
      switch (action) {
        case 'archive':
          this.deleteManySeviceOrders()
          break
        case 'download':
          this.getZip()
          break
        case 'email':
          this.openSendEmail()
      }
    },
  },

  watch: {
    unidadeId() {
      if (this.unidadeId) {
        this.localDepartments = this.departments.filter(
          (x) => x.unidadeId == this.unidadeId
        )
      } else {
        this.localDepartments = this.departments.filter((x) =>
          this.unidades.map((x) => x.id).includes(x.unidadeId)
        )
      }
    },

    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = 1
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },

    serviceOrdersSelected() {
      this.buttonDeleteVisible = this.serviceOrdersSelected
        ? this.serviceOrdersSelected.length > 0
        : false
    },
  },
}
